import lockScroll from '../__utils/lockScroll';

const $ = jQuery.noConflict();

class petangoLightbox {
    constructor() {
        this.lightboxOpen = $('.petango-lightbox__trigger');
        this.lightboxClose = $('.petango-pet-popup__close');
        this.containerWrapper = $('.petango-pet-popup');
    }
    init() {
        this.bindEvents();
    }
    bindEvents() {
        this.lightboxOpen.on('click', this.openLightbox);
        this.lightboxClose.on('click', this.closeLightbox);
		this.containerWrapper.on('click', this.hideLightboxOnTouch);
    }
    openLightbox(e) {
        e.preventDefault();
        const petangoBlock = $(this).closest('.block-petango-embed'); 
        petangoBlock.find('.petango-pet-popup').addClass('active');
        lockScroll.lock();
    }
    closeLightbox() {
        const lightboxWrapper = $(this).closest('.petango-pet-popup');
        lightboxWrapper.removeClass('active');
        lockScroll.unlock();
    }
	hideLightboxOnTouch(e) {
		const container = $('.petango-pet-popup__container');
		if (!container.is(e.target) && container.has(e.target).length === 0 && !$('.petango-lightbox-trigger').is(e.target) && $('.petango-pet-popup').hasClass('active')) {
			$('.petango-pet-popup').removeClass('active');
			lockScroll.unlock();
		}
	}
}
export default new petangoLightbox();
